import { HeaderState, updateHeader } from "@soluto-private/mx-app-header";
import {
  AuthenticationState,
  getAuthenticationState,
} from "@soluto-private/mx-app-authentication";

export const updateMxHeader = (
  headerState: HeaderState & { client: string },
) => {
  if (
    headerState.homePath &&
    getAuthenticationState().toString() === AuthenticationState.LoggedIn
  ) {
    //TODO logic below is only until the dashboard supports verizon
    headerState.homePath = headerState.homePath.includes("dashboard")
      ? "/dashboard"
      : "/hub";
  } else {
    headerState.homePath = `/mobile-device-setup/intro?mxclient=${headerState.client}`;
  }

  headerState.subNavConfig = {
    showPartnerLogo:
      !headerState.client ||
      ["koodo", "uscellular", "telus", "asurion"].includes(headerState.client)
        ? false
        : true,
    ...headerState.subNavConfig,
  };

  updateHeader(headerState);
};
